import Vue from "vue";
import Vuelidate from "vuelidate";
import VueSweetAlert2 from "vue-sweetalert2";
import LoadScript from "vue-plugin-load-script";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import filters from "./filters";
import focus from "./directives/focus";
import VueTimers from 'vue-timers'
import UUID from "vue-uuid";

Vue.config.productionTip = false;
Vue.use(filters);
Vue.use(Vuelidate);
Vue.use(VueSweetAlert2);
Vue.use(LoadScript);
Vue.use(VueTimers);
Vue.use(UUID);
Vue.directive("focus", focus);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
